module.exports = {
  label: 'ประวัติไฟล์',
  Details: 'รายละเอียดคุณสมบัติ',
  view: 'ดูไฟล์',
  PlsInput: 'กรุณากรอก',
  Query: 'ค้นหา',
  fileName: 'ชื่อไฟล์',
  fileVersion: 'เวอร์ชัน',
  jobType: 'ประเภทไฟล์',
  fileType: 'รูปแบบไฟล์',
  fileSize: 'ขนาดไฟล์',
  createdBy: 'ผู้สร้าง',
  createdDate: 'วันที่สร้าง',
  tagName: 'ชื่อคุณสมบัติ',
  tagValue: 'ค่าคุณสมบัติ',
  Tips: 'แจ้งเตือน',
  DownloadFile: 'ต้องการบันทึกไฟล์หรือไม่?',
  Succeed: 'ดาวน์โหลดสำเร็จ',
  Failed: 'ดาวน์โหลดไม่สำเร็จ',
  noFile: 'ไม่มีประวัติการทำงาน',
  Refresh: 'รีเฟรช',
  Upload: 'อัปโหลด',
  Delete: 'ลบ',
  BatchDownload: 'ดาวน์โหลดแบบกลุ่ม',
  SendEmail: 'ส่งอีเมล',
  TransferAllToFileHistory: 'บันทึกทั้งหมดไปยังประวัติไฟล์',
  ingotUpload: 'อัปโหลด Ingot',
  ingotLog: 'บันทึก Ingot',
  preview: 'ดูตัวอย่าง',
  synchronization: 'ซิงค์',
  cancelSynchronization: 'ยกเลิกการซิงค์',
  synchronizationState: 'สถานะการซิงค์',
  operation: 'ดำเนินการ',
  fileDownload: 'ดาวน์โหลดไฟล์',
  ExternalFileType: 'ประเภทไฟล์ภายนอก',
  LastSyncTime: 'เวลาซิงค์ล่าสุด',
  DisplayTicketFile: 'แสดงไฟล์ใบเสร็จ',
  SendDestinationPortAgent: 'ส่งให้ตัวแทนท่าเรือปลายทาง',
  SentDestinationPortAgent: 'ส่งให้ตัวแทนท่าเรือปลายทางแล้ว',
  ResetOneClickSend: 'รีเซ็ตการส่งแบบด่วน',
  FileCreator: 'ผู้สร้างไฟล์',
  FileCreationDate: 'วันที่สร้างไฟล์',
  HasDeleted: 'ต้องการลบหรือไม่?',
  SendSetOfProxyOrders: 'ส่งชุดเอกสารให้ตัวแทน',
  ProxyName: 'ชื่อตัวแทน'
}
